var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "process" },
    [
      _c(
        "el-steps",
        {
          attrs: {
            active: _vm.active,
            "finish-status": "success",
            "align-center": "",
          },
        },
        [
          _c("el-step", {
            attrs: {
              title: _vm.$t("Progress.readData"),
              icon: _vm.setIcon(0, "el-icon-upload"),
              status: _vm.setStatus(0),
              description: _vm.setDescription(0),
            },
          }),
          _vm._v(" "),
          _c("el-step", {
            attrs: {
              title: _vm.$t("Progress.checkHeader"),
              icon: _vm.setIcon(1, "el-icon-s-order"),
              status: _vm.setStatus(1),
              description: _vm.setDescription(1),
            },
          }),
          _vm._v(" "),
          _c("el-step", {
            attrs: {
              title: _vm.$t("Progress.checkData"),
              icon: _vm.setIcon(2, "el-icon-s-platform"),
              status: _vm.setStatus(2),
              description: _vm.setDescription(2),
            },
          }),
          _vm._v(" "),
          _c("el-step", {
            attrs: {
              title: _vm.$t("Progress.importData"),
              icon: _vm.setIcon(3, "el-icon-s-opportunity"),
              status: _vm.setStatus(3),
              description: _vm.setDescription(3),
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }